import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button, Text, Alert, Modal } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import api from "~/lib/api";
import { handleError } from "~/lib/helpers";
import workingStyleCreateSchema from "~/forms/WorkingStyleCreateForm/workingStyleCreateSchema";
import WorkingStyleCreateForm from "~/forms/WorkingStyleCreateForm";
import VerifyCodeModal from "~/components/VerifyCodeModal";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const PublicWorkingStyleCreateModal = _ref => {
  let {
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const defaultValues = {
    firstName: "",
    email: ""
  };
  const [verifyCodeOpen, setVerifyCodeOpen] = useState(false);
  const {
    handleSubmit,
    reset,
    watch,
    control
  } = useForm({
    resolver: yupResolver(workingStyleCreateSchema),
    defaultValues
  });
  useEffect(() => {
    reset(defaultValues);
    setError(undefined);
  }, [open]);
  const onSubmit = handleSubmit(_ref2 => {
    let {
      email
    } = _ref2;
    setIsLoading(true);
    api.validateWorkingStyleEmail(email).then(() => {
      setVerifyCodeOpen(true);
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setIsLoading(false);
    });
  });
  const handleClose = () => {
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("PublicWorkingStyleCreateModal.createProfile"),
    onClose: handleClose,
    fullWidth: true,
    maxWidth: "420px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    s: {
      mb: 3
    }
  }, t("PublicWorkingStyleCreateModal.description")), /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    s: {
      mb: 3
    }
  }, t("PublicWorkingStyleCreateModal.note")), /*#__PURE__*/React.createElement(WorkingStyleCreateForm, {
    control: control
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleClose,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    loading: isLoading,
    s: {
      ml: 2
    },
    fullWidth: true,
    rounded: true
  }, t("common.actions.create")))), /*#__PURE__*/React.createElement(Modal, {
    open: verifyCodeOpen
  }, /*#__PURE__*/React.createElement(VerifyCodeModal, {
    firstName: watch("firstName"),
    email: watch("email"),
    onClose: () => setVerifyCodeOpen(false)
  })));
};
export default PublicWorkingStyleCreateModal;